import { t } from "i18next";
import { useCalendar } from "./CalendarContext";
import { useEffect, useRef, useState } from "react";
import { useModal } from "../../../core/context/ModalContext";
import AppointmentPreviewApp from "../preview/AppointmentPreviewApp";

export default function AppointmentMenu() {
    const { selectedAppointment, setSelectedAppointment, refresh } = useCalendar();
    const prevId = useRef(null)
    const { openModal, closeModal } = useModal()

    useEffect(() => {
        console.log('App:', prevId.current, selectedAppointment.appointmentId)
        if (prevId.current !== selectedAppointment.appointmentId && selectedAppointment.appointmentId) {
            prevId.current = selectedAppointment.appointmentId
            openModal(t('Appointment'), (
                <AppointmentPreviewApp
                    appointmentId={selectedAppointment.appointmentId}
                    onDelete={() => {
                        closeModal()
                        refresh()
                    }}
                />
            ), () => refresh())
        }

        if (!selectedAppointment.appointmentId)
            prevId.current = null

    }, [selectedAppointment.appointmentId]);

    return (
        <>
            <div
                style={{
                    display: 'flex',
                    gap: 8,
                    flexWrap: 'wrap'
                }}
            >

            </div>
        </>
    )
}
